export const ItemTypes = {
  QUESTION: 'question'
}